export const StorageKeys = {
    language: "language",
    token: "token",
    user: "user",
    CMSMode: "CMSMode",
    refreshToken: "refreshToken",
    redirectionURL : "redirectionURL",
    rememberedCredentials: "rememberedCredentials"
  }
